import i18n from "@/i18n";

export const formattedAreaInHa = (value: number) => {
  const convertedArea = Number(value) || 0;
  return `${i18n.n(convertedArea, 'rounded-number')} ha`;
}


export const formattedLargerAreas = (value: number) => {
  const convertedArea = Number(value) || 0;
  if(convertedArea > 999) {
    return `${i18n.n(convertedArea/1000, 'rounded-number')}`
  } else {
    return `${i18n.n(convertedArea, 'rounded-number')} ha`
  }
  
}
